<template>
  <div>
    <el-card>
      <div slot="header" class="clearfix">
        <span>基本信息</span>
      </div>
      <el-descriptions
        :column="2"
        :contentStyle="{ height: '35px' }"
        v-loading="loading"
      >
        <el-descriptions-item label="抽取名称">
          {{ info.title }}
        </el-descriptions-item>
        <el-descriptions-item label="抽取年度">
          {{ info.workYear }}
        </el-descriptions-item>
        <el-descriptions-item label="抽取级别">
          {{ info.levelName }}
        </el-descriptions-item>
        <el-descriptions-item label="抽取类型">
          {{ info.typeName }}
        </el-descriptions-item>
        <el-descriptions-item label="需专家总数">
          <span>{{ info.needCount }}</span>
          （
          <span>自行推荐:{{ info.selfCount }}，</span>
          <span>随机抽取:{{ info.randCount }}</span>
          ）
        </el-descriptions-item>
        <el-descriptions-item label="评审机构">
          {{ info.boardName }}
        </el-descriptions-item>
        <el-descriptions-item label="新增时间">
          <span>{{ moment(info.addTime).format('YYYY-MM-DD HH:mm:ss') }}</span>
        </el-descriptions-item>
      </el-descriptions>
    </el-card>
  </div>
</template>

<script>
import { getBase } from '@/api/gains/reviews/base.js';

export default {
  data() {
    return {
      info: {},
      loading: false
    };
  },
  props: {
    isChange: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getData() {
      this.loading = true;
      getBase(this.$route.params.gainEid).then(res => {
        this.loading = false;
        this.info = res;

        const countTip = this.isChange
          ? ''
          : `-需总数:${res.needCount}(自行:${res.selfCount}随机:${res.randCount})`;
        this.$emit('set-title', {
          title: `名称：${res.title}`,
          subTitle: `${res.boardName}${countTip}`
        });
      });
    }
  },
  created() {
    this.getData();
  }
};
</script>

<style></style>
